import { render, staticRenderFns } from "./JcdcTabs.vue?vue&type=template&id=211f7e8b"
import script from "./JcdcTabs.vue?vue&type=script&lang=ts"
export * from "./JcdcTabs.vue?vue&type=script&lang=ts"
import style0 from "./JcdcTabs.vue?vue&type=style&index=0&id=211f7e8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports